import FileModel from './globals/FileModel';

export default class ShowMediaModel extends FileModel {
  static get path() {
    return '/backend/show_media/{?id}';
  }
}
